<template>
  <div class="tw-h-screen">
    <div
v-if="loading"
class="tw"
>
      <div class="tw-h-screen tw-flex tw-items-center tw-justify-center">
        <VueSpinnerOrbit size="8em" />
      </div>
    </div>
    <div
v-else
class="tw"
>
      <TopToolbar
          :quote-name="quoteName"
          :mode="store.addProductToggle"
          @edit-quote="showEditQuoteModal = true"
          @add-frame="showSidebar = true"
          @email-quote="showEmailModal = true"
          @view-quote="viewQuote"
          @change-mode="changeMode"
      />
      <transition name="slide-fade">
        <Sidebar
            v-if="showSidebar"
            :products="products"
            @close="showSidebar = false"
            @add-product="addProduct"
        />
      </transition>

      <CustomizeModal
          v-if="showCustomizeModal"
          :frame="selectedFrame"
          @close="showCustomizeModal = false"
          @save-frame="saveCustomizations"
      />

      <EditQuoteModal
          v-if="showEditQuoteModal"
          v-model:quoteName="quoteName"
          @close="showEditQuoteModal = false"
          @update="runUpdate"
      />

      <SendQuoteModal
          v-if="showEmailModal"
          @close="showEmailModal = false"
          @sendEmail="sendEmail"
      />
      <div
          v-if="!store.addProductToggle"
          class="tw-min-h-screen tw-bg-gray-100"
      >
        <FrameGrid
            :frames="frames"
            @customize="customizeFrame"
            @delete="deleteFrame"
            @edit="editItem"
        />
      </div>
      <div v-else>
        <DesignerPage />
      </div>
    </div>
  </div>
</template>

<script>
import {useQuoteStore} from "@/stores/QuoteStore";
import TopToolbar from './components/TopToolbar.vue';
import Sidebar from './components/Sidebar.vue';
import CustomizeModal from './components/CustomizeModal.vue';
import EditQuoteModal from './components/EditQuoteModal.vue';
import FrameGrid from './components/FrameGrid.vue';
import SendQuoteModal from "@/components/backend/pages/quoting/components/SendQuoteModal.vue";
import {VueSpinnerOrbit} from "vue3-spinners";
import { inject } from "vue";
import { useToast } from "vue-toastification";
import {useDesignerStore} from "@/stores/DesignerStore";
import {useCoreStore} from "@/stores/CoreStore";
import DesignerPage from '@/components/backend/pages/designer/page.vue'

export default {
  name: "QuotePage",
  components: {DesignerPage, TopToolbar, Sidebar, CustomizeModal, EditQuoteModal, FrameGrid, VueSpinnerOrbit, SendQuoteModal},
  inject: ['coreService'],
  setup() {
    const store = useQuoteStore();
    const designerStore = useDesignerStore();
    const coreStore = useCoreStore()


    return {store, designerStore, coreStore};
  },
  data() {
    return {
      addProductToggle: false,
      editProductToggle: false,
      productEditing: {},
      productAdding: {},
      quoteService: {},
      quoteInfo: {}
    }
  },
  computed: {
    loading: {
      get() {
        return this.store.loading;
      },
      set(value) {
        this.store.loading = value;
      }
    },
    showSidebar: {
      get() {
        return this.store.showSidebar;
      },
      set(value) {
        this.store.showSidebar = value;
      }
    },
    showEditQuoteModal: {
      get() {
        return this.store.showEditQuoteModal;
      },
      set(value) {
        this.store.showEditQuoteModal = value;
      }
    },
    showCustomizeModal: {
      get() {
        return this.store.showCustomizeModal;
      },
      set(value) {
        this.store.showCustomizeModal = value;
      }
    },
    showEmailModal: {
      get() {
        return this.store.showEmailModal;
      },
      set(value) {
        this.store.showEmailModal = value;
      }
    },
    quoteName: {
      get() {
        return this.store.quoteName;
      },
      set(value) {
        this.store.quoteName = value;
      }
    },
    products() {
      return this.store.products;
    },
    frames() {
      return this.store.frames;
    },
    selectedFrame: {
      get() {
        return this.store.selectedFrame;
      },
      set(value) {
        this.store.selectedFrame = value;
      }
    }
  },
  mounted() {
    let quoteService = inject('quoteBuilderService')
    let quoteInfo = inject('settings')
    this.quoteService = quoteService;
    this.quoteInfo = quoteInfo

    quoteService.getQuote();

    let _this = this;
    window.addEventListener('itemAddedToCart', (e) => {
      _this.updateQuote();
    })
  },
  methods: {
    addProduct(product) {
      this.coreStore.pageData.productId = product.id
      this.coreStore.quoteId = this.store.quoteObj.id

      this.designerStore.itemType = 'quote'
      this.store.addProductToggle = true
      this.showSidebar = false;
      this.editProductToggle = false
      this.productEditing = null
    },
    async saveCustomizations(frame) {
      await this.quoteService.updateQuoteItem(frame, {
        "custom_attributes": frame.custom_attributes
      })

      this.updateQuote()
    },
    customizeFrame(frame) {
      this.store.customizeFrame(frame);
    },
    changeMode() {
      this.store.addProductToggle = !this.store.addProductToggle
      this.designerStore.resetStore()
    },
    updateQuote() {
      this.quoteService.getQuote()
    },
    editItem(frame) {
      console.log(frame);
      this.coreStore.pageData.productId = frame.raw_data.product_id
      this.coreStore.quoteId = this.store.quoteObj.id
      this.designerStore.itemId = frame.uuid;
      this.designerStore.setSelectedOptions(frame.raw_data, false)
      this.designerStore.editing = true
      this.designerStore.itemType = 'quote'
      this.store.addProductToggle = true
      this.showSidebar = false;
      this.editProductToggle = false
      this.productEditing = null
      this.productEditing = frame
    },
    async deleteFrame(frame) {
      if (confirm('Delete ' + frame.name + '?')) {
        await this.quoteService.deleteQuoteItem(frame.uuid)
        this.quoteService.getQuote();
      }
    },
    runUpdate() {
      let quoteStore = useQuoteStore()
      this.quoteService.updateQuote(quoteStore.quoteObj)
      alert("Quote updated")
    },
    sendEmail(data) {
      this.quoteService.emailQuote(data)
      alert("Quote sent via email")
    },
    viewQuote() {
      window.open(process.env.VUE_APP_API_URL + "/quote/specification/" + this.coreStore.pageData.uuid, "_blank");
    }
  }
};
</script>
